module.exports = __webpack_public_path__ + "img/tbchsm.048adf16.png";